"use client";

import React from "react";
import EditSection, { TextEditor, ListItemEditor } from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function PortfolioGridEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  const defaultProjects = [
    { title: "E-Commerce App", category: "Mobile Development", link: "#", imageUrl: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=600&fit=crop" },
    { title: "Branding Agency", category: "Visual Identity", link: "#", imageUrl: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=800&h=600&fit=crop" },
    { title: "Crypto Dashboard", category: "Web Design", link: "#", imageUrl: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop" }
  ];

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <div className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Section Headers</h4>
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => handleChange({ ...content, title: v })}
              placeholder="Selected Work"
            />
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Projects List</h4>
            <ListItemEditor
              label="Projects"
              items={content.projects || defaultProjects}
              itemSchema={[
                { key: "title", label: "Project Title", type: "text" },
                { key: "category", label: "Category", type: "text" },
                { key: "link", label: "Link URL", type: "text" },
                { key: "imageUrl", label: "Project Image URL", type: "image" },
              ]}
              onChange={(items) => handleChange({ ...content, projects: items })}
              addItemText="Add Project"
            />
          </div>
        </div>
      }
    />
  );
}
